import React, {useState, useEffect, useContext} from 'react';
import '../../css/conversation.css';
import '../../css/quilityIcons.css';
import { fetchWithDefaults } from '../../config/fetchDefault';
import ConvoBlock from './convoBlock';
import ActualConversation from './conversation';
import LeadData from './leadData';
import { useSelector, useDispatch } from 'react-redux';
import { decrementUnreadMessages, setConversations } from '../../features/conversationSlice';
import {setOpenMessages} from '../../features/topBarSlice';
import {setConvoWindow} from '../../features/conversationSlice';
import { getConversations } from '../../utilities/appSetup';
import { setCall } from '../../features/callSlice';
import { sanitizeTextMessage } from '../../utilities/messagingFunctions';
import { fetchLeadDataThunk } from '../../features/leadDataInfoSlice';
import { AgentContext } from '../../context/AgentContext';
import { brandedButtonTypes } from '../../utilities/inputComponents/BrandedButton';
import XClose from '../../svgIcon/XClose';
import BrandedIconButton from '../../utilities/inputComponents/BrandedIconButton';

/**
 * Note using the lead data found in leadDataInfoSlice in this component.
 * The lead data used here is returned from a different endpoint (/conversation/getConvo?convo=<convo>).
 * It is possible that the lead data in the response does not align with the lead data returned from the /lead/leadCard?lead=<leadId> endpoint.
 *
 * The lead_id value returned from the conversation endpoint will still be used to update the lead card via the call to fetchLeadDataThunk
 */

function Conversations({ setLeadCard, setNewAppt, newAppt, setLoading, setCallerId, handleSoftPhone, unreadMessages, device, handleSetUnread, newMessages}) {

    //setCall
    const dispatch = useDispatch();
    const [activeFilter, setActiveFilter] = useState('');
    const agentInfo=useSelector((state) => state.agent.userData);
    const conversations=useSelector((state) => state.conversations.conversations);
    const currentConvoId=useSelector((state) => state.conversations.currentConvoId);
    const messagesState=useSelector((state) => state.topBar.messages);
    const [expanded, setExpanded] = useState(false);
    const [conversation, setConversation] = useState(false);
    const [lead, setLead] = useState(false);
    const [convoId, setConvoId] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [flowData, setFlowData]=useState(false);
    const handleInputChange = (content) => {
        setInputValue(content);
    };

    const handleUpdateConversation=(message)=>{
        // Validate message has required fields
        if (!message || !message.convo_id) {
            return;
        }

        let keyFound = false;
        let shouldUpdate = false;

        const updatedState = conversations.map(obj => {
            if (obj.convo_id === message.convo_id) {
                keyFound = true;
                const existingTime = Number(obj.time) || 0;
                const newTime = Number(message.time) || 0;
                
                if (newTime > existingTime || obj.message !== message.message) {
                    shouldUpdate = true;
                    return message;
                }
                return obj;
            }
            return obj;
        });
        if (!keyFound) {
            // Conversation not found, add the message to state
            updatedState.push(message);
            shouldUpdate = true;
        }

        // Only dispatch update if something actually changed
        if (shouldUpdate) {
            const sortedConversations = [...updatedState].sort((a, b) => {
                return Number(b.time) - Number(a.time); // Descending order
            });
            dispatch(setConversations(sortedConversations));
        }
    }

    const clearRead= async (id)=>{
        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    convo: id
                })
            };

            const response = await fetchWithDefaults('/conversation/clearUnreadMessage', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            dispatch(decrementUnreadMessages())
          } catch (error) {
            console.error('Error fetching data:', error);
          }
    }
    const timestamp = () => {
        const currentDate = new Date();
        const millisecondsSinceEpoch = currentDate.getTime();
        const unixTimestamp = Math.floor(millisecondsSinceEpoch / 1000);
        return unixTimestamp;
    };

    const handleClose=()=>{
        setExpanded(false)
        dispatch(setOpenMessages(false))
        dispatch(setConvoWindow(false));
    }
    const handleExpanded= async (convo, lead)=>{

        if(expanded===false){
            setExpanded(true);
        }
    
        // If lead parameter is not provided, try to find it from the conversations list
        let leadId = lead;
        if (!leadId) {
            const currentConvo = conversations.find(conv => conv.convo_id === convo);
            leadId = currentConvo?.lead_id;
        }
        const response = await fetchWithDefaults(`/conversation/getConvo?convo=${convo}&lead=${leadId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        if(jsonData[0].lead){
            setLead(jsonData[0].lead)

            // make sure that the correct lead is loaded
            // into the lead card
            await dispatch(fetchLeadDataThunk({leadId: jsonData[0].lead[0].lead_id}))
        }
        setConversation(jsonData[0].convo);
        setConvoId(convo)

        const updatedState = conversations.map(obj => {
            if (obj.convo_id === convo) {
                if (obj.message_read === 'no') {
                    clearRead(obj.convo_id);
                    // Create a new object with updated message_read property
                    return {
                        ...obj,
                        message_read: 'yes'
                    };
                }
            }
            // Return the original object if no update is necessary
            return obj;
        });

        if(newMessages.length === 0){
            dispatch(setConversations(updatedState));
        }
    }
    const closeData = ()=>{
        setFlowData(false);
    }
    function UnixTimestampToDate(unixTimestamp) {
        // Create a new Date object from the Unix timestamp (in milliseconds)
        const date = new Date(unixTimestamp * 1000);

        // Get the month and day from the date object
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');

        // Format the date as "MM/DD"
        const formattedDate = `${month}/${day}`;

        return formattedDate;
    }

    const travelPathway= async (lead,path)=>{
        try {
            const response = await fetchWithDefaults(`/travelPath?lead=${lead}&path=${path}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const stopFlow = async (id)=>{
        try {
            const response = await fetchWithDefaults(`/stopFlow?flow=${id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setFlowData(false);
            let index=0;
            setLead(prevData => {
                const newData = [...prevData];
                // Check if index is valid
                if (index >= 0 && index < newData.length) {
                // Update the field value for the object at the specified index
                newData[index] = {
                    ...newData[index],
                    ['wf_name']: null,
                    ['wf_id']: null
                };
                }
                return newData;
            });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleSendText= async (message,convoId,image)=>{
        const textToSend = sanitizeTextMessage(message)
        const actualLead=lead[0].lead_id;
        const newMessage={
            lead_id: actualLead,
            message: textToSend,
            sent_from: "from",
            image:image,
            time: timestamp()
        }
        const pendingMessage={
            lead_id: actualLead,
            message: textToSend,
            pending:true,
            sent_from: "from",
            image:image,
            time: timestamp()
        }
        const toFrom=atob(convoId).split(':');
        const to=toFrom[1];
        const from=toFrom[0];
        setInputValue("");
        const updatedPending = [pendingMessage, ...conversation];
        const updatedConversation = [newMessage, ...conversation];
        setConversation(updatedPending);

        // Store the latest conversation in redux
        const updatedLastConversations = conversations.map(convo => {
            // If `lead_id` matches, update `message` and `time`
            if (convo?.lead_id === pendingMessage?.lead_id) {
                return {
                    ...convo, // Preserve existing fields
                    message: pendingMessage.message, // Update message
                    time: pendingMessage.time // Update time
                };
            }
            return convo; // Return original if no match
        });
        dispatch(setConversations(updatedLastConversations));

       try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentInfo.agentId,
                    to:to,
                    from:from,
                    body:textToSend,
                    team:agentInfo.teamId,
                    lead:lead[0].lead_id,
                    first:lead[0].borrower_first,
                    last:lead[0].borrower_last,
                    image:image,
                })
            };
            const response = await fetchWithDefaults('/sendText', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            setConversation(updatedConversation);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect( () => {
        if(newMessages.length > 0){
            handleUpdateConversation(newMessages[0]);
        }
        if(convoId){
            if(newMessages[newMessages.length - 1]?.convo_id===convoId && expanded===true){
                dispatch(decrementUnreadMessages())
                handleExpanded(convoId);
            }
        }
    },[newMessages])

    useEffect( () => {
        if(currentConvoId){
            handleExpanded(currentConvoId)
        }
        return () => {
            setConversation(false)
        }
    },[currentConvoId])

    useEffect( () => {
        if(messagesState && conversations.length < 1){
            getConversations(agentInfo.agentId, dispatch);
        }
    },[messagesState])

    const makeDial= async (toNumber, callee, fromNum)=>{

        if(!fromNum){
            fromNum=lead[0].call_from;
        }
        const call= await device.connect({ params: { To: '+1'+toNumber , callerId: fromNum, user:agentInfo.agentId, tone: "default", leadId:lead[0].lead_id }});
        dispatch(setCall(call));
        handleSoftPhone(call.status());
        setCallerId({name:callee, lead_id:lead[0].lead_id});
        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentInfo.agentId,
                    team: agentInfo.teamId,
                    agentNumber:fromNum,
                    clientNumber:toNumber,
                    leadId:lead[0].lead_id
                }),
            };

            const response = await fetchWithDefaults('/queueDial', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleLeadData=(field, value)=>{
        let index=0;
        setLead(prevData => {
            const newData = [...prevData];
            // Check if index is valid
            if (index >= 0 && index < newData.length) {
              // Update the field value for the object at the specified index
              newData[index] = {
                ...newData[index],
                [field]: value
              };
            }
            return newData;
        });
    }

    const openLead=(lead)=>{
        setLeadCard([lead]);
    }
    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector((state) => state.colorData)
    const filterMessages=(type)=>{
        getConversations(agentInfo.agentId, type, dispatch);
        setActiveFilter(type);
    }
    return (
        <AgentContext.Provider value={{isB2B}}>
            <div className={`leaderBoardWrapper ${messagesState && expanded ? 'expanded': messagesState ? 'openedLeaderBoard' : ''}`}>
                <div className='convos-close-button-wrapper'>
                    <BrandedIconButton clickHandler={_ => handleClose()} buttonType={brandedButtonTypes.TERTIARY} >
                        <XClose />
                    </BrandedIconButton>
                </div>

                <div className="convoEntireWrapper">
                    <div className={`conversationLeft ${expanded ? 'convoAdjust' : ''}`}>
                        <div className="convoTitle">Recent Chats</div>
                        <div className="messageFilterHolder">
                            <div className={`messageFilterButton ${activeFilter === '' ? 'quilityActiveTab' : ''}`} onClick={()=>filterMessages("")}>All</div>
                            <div className={`messageFilterButton ${activeFilter === 'Unread' ? 'quilityActiveTab' : ''}`} onClick={()=>filterMessages("Unread")}>Unread</div>
                            <div className={`messageFilterButton ${activeFilter === 'Incoming' ? 'quilityActiveTab' : ''}`} onClick={()=>filterMessages("Incoming")}>Incoming</div>
                        </div>
                        <div className="convoListInnerWrapper">
                            {conversations.status !== false && conversations.length!==0 ? (
                                conversations.map((convo, index) => (
                                    <ConvoBlock convo={convo} handleExpanded={handleExpanded} key={`conversation${index}`} />
                                ))
                            ) : (
                                <div className="noConvos">No conversations found.</div>
                            )}
                        </div>
                    </div>
                    {expanded && (
                        <>
                            <div className="conversationCenter">
                                <div className="convoTitle" style={{margin: 'unset'}}>Active Conversation</div>
                                <ActualConversation setLoading={setLoading} travelPathway={travelPathway} lead={lead} handleInputChange={handleInputChange} inputValue={inputValue} convoId={convoId} handleSendText={handleSendText} conversation={conversation}/>
                            </div>
                            <div className="conversationRight rightAdjustment">
                                <div className={`viewLeadButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>openLead(lead)}>Open Lead</div>
                                {lead && (
                                   lead.length > 0 && (
                                        <LeadData from="conversations" setNewAppt={setNewAppt} newAppt={newAppt} makeDial={makeDial} handleLeadData={handleLeadData} lead={lead}/>
                                    )
                                )}
                            </div>
                            {flowData && (
                                <div className="flowDataWrapper">
                                    <div className="flowDataContent">
                                        <div className="closeWindow" onClick={()=>closeData()}>X</div>
                                        {flowData.map((item, index) => (
                                            <span key={`flowData${index}`}>
                                                <div className="title">Workflow Info</div>
                                                <div className="flowDataInfoWrapper">
                                                    <div className="flowDataInfoTitle">
                                                        Workflow Name:
                                                    </div>
                                                    <div className="flowDataInfoInfo">
                                                        {item.name}
                                                    </div>
                                                </div>
                                                <div className="flowDataInfoWrapper">
                                                    <div className="flowDataInfoTitle">
                                                        Date Started:
                                                    </div>
                                                    <div className="flowDataInfoInfo">
                                                        {UnixTimestampToDate(item.start)}
                                                    </div>
                                                </div>
                                                <div className="flowDataInfoWrapper">
                                                    <div className="flowDataInfoTitle">
                                                        Workflow Length:
                                                    </div>
                                                    <div className="flowDataInfoInfo">
                                                        {item.totalResult} Actions
                                                    </div>
                                                </div>
                                                <div className="flowDataInfoWrapper">
                                                    <div className="flowDataInfoTitle">
                                                        Actions Remaining:
                                                    </div>
                                                    <div className="flowDataInfoInfo">
                                                        {item.activeCount}
                                                    </div>
                                                </div>
                                                <div className="buttonWrapper">
                                                    <div className="accentButton" style={{margin:'auto', marginTop:'25px'}} onClick={()=>stopFlow(item.theId)}>Stop Workflow</div>
                                                </div>
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </AgentContext.Provider>
    );
}

export default Conversations;
